import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetOwnerAction } from '../../../../ts/ServerApi/types/actionNames';
import { setOwner } from '../../../actions/spaces/SetOwnerAction';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const SetOwnerAction: IEntityAction<IContentInfo, ISetOwnerAction> = {
  name: 'setOwner',
  translateName: Messages.changeOwner_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetOwnerAction) => !!(availableActions && availableActions.setOwner),
  createReduxAction: (targetItems: IContentInfo[]) => setOwner(targetItems)
};
